import type { Lang } from '@aera/schema';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/ui.js';

/** "Delete my data": backs the promise on the consent sheet; the consultant is notified. */
export function DeleteRequest({ lang, onRequest }: { lang: Lang; onRequest: () => Promise<unknown> }) {
  const { t } = useTranslation();
  const [state, setState] = useState<'idle' | 'confirm' | 'busy' | 'done' | 'failed'>('idle');
  if (state === 'done') return <p className="text-black">{t('brief.deleteDone', { lng: lang })}</p>;
  return (
    <div>
      {t('brief.deleteLead', { lng: lang })}{' '}
      {state === 'idle' || state === 'failed' ? (
        <button type="button" className="underline underline-offset-4 hover:text-black" onClick={() => setState('confirm')}>
          {t('brief.deleteButton', { lng: lang })}
        </button>
      ) : (
        <span className="mt-2 block rounded-2xl bg-surface p-3 text-black">
          {t('brief.deleteConfirm', { lng: lang })}
          <span className="mt-2 flex gap-2">
            <Button
              size="sm"
              variant="danger"
              busy={state === 'busy'}
              onClick={async () => {
                setState('busy');
                try {
                  await onRequest();
                  setState('done');
                } catch {
                  setState('failed');
                }
              }}
            >
              {t('brief.deleteButton', { lng: lang })}
            </Button>
            <Button size="sm" variant="ghost" onClick={() => setState('idle')}>
              {t('common.cancel', { lng: lang })}
            </Button>
          </span>
        </span>
      )}
      {state === 'failed' && <span className="ml-2 text-red-700">{t('common.error', { lng: lang })}</span>}
    </div>
  );
}
